var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleaningIconSpinning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "h57l6jnama"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.01953 0 0 0 0 0.6953125 0 0 0 0 0.6640625 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "we5y7ixq1b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.01953 0 0 0 0 0.6953125 0 0 0 0 0.6640625 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#h57l6jnama)",
    transform: "translate(-595 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#we5y7ixq1b)",
    transform: "translate(595 204)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E36510",
    stroke: "#E36510",
    d: "M8.938.06c1.59 0 4.29.716 4.385 4.288.08 3.03-1.61 4.348-2.856 4.906l.215.003c4.245 0 3.006-3.273 5.298-3.451.101-.008.2-.013.295-.013 2.145 0 2.747 1.962 2.78 2.987.049 1.562-.59 4.445-4.285 4.546l-.206.003c-2.885 0-4.155-1.642-4.7-2.858-.112 4.498 3.267 3.183 3.448 5.512.189 2.382-1.907 3.04-2.974 3.072-.052.002-.106.003-.161.003-1.591 0-4.288-.716-4.386-4.285-.08-3.04 1.622-4.354 2.866-4.91l-.22-.002c-4.249 0-3.012 3.277-5.303 3.455-.1.008-.2.012-.294.012-2.142 0-2.748-1.965-2.778-2.986-.048-1.562.59-4.45 4.282-4.547l.206-.003c2.894 0 4.162 1.653 4.704 2.869.115-4.515-3.271-3.194-3.452-5.523C5.613.753 7.709.098 8.776.063 8.829.06 8.883.06 8.938.06",
    transform: "translate(2.941 2.941)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningIconSpinning);
export default __webpack_public_path__ + "static/media/cleaning-icon-spinning.f8feb3dacc0b315b0f4f7dd8f2ed3bf0.svg";
export { ForwardRef as ReactComponent };